"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["children", "classes", "className", "disabled", "displayErrors", "hasError", "hasValidation", "inputClassName", "inputRef", "name", "placeholder", "readOnly", "setDisplayErrorsState", "setLoadingState", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type Node, type ElementRef } from 'react';*/
/*:: import type {
  InjectSheetProvidedProps,
  ThemeType
} from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.extraSmallText), {}, {
      color: theme.colors.black,
      position: 'relative',
      cursor: 'pointer',
      display: 'flex'
    }),
    input: {
      margin: '.2rem .5rem'
    },
    placeholder: {
      color: theme.colors.slateGrey
    }
  };
};
/*:: export type CheckboxInputType = InjectSheetProvidedProps & {
  children: Node,
  disabled?: boolean,
  displayErrors?: boolean,
  hasError?: boolean,
  hasValidation?: boolean,
  inputClassName?: string,
  inputRef?: ElementRef<*>,
  name: string,
  placeholder?: string,
  readOnly?: boolean,
  setDisplayErrorsState?: (displayErrors: boolean) => mixed,
  setLoadingState?: (loading: boolean) => mixed
};*/
var CheckboxInput = function CheckboxInput(_ref /*:: */) /*: Node*/{
  var children = _ref /*:: */.children,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    disabled = _ref /*:: */.disabled,
    displayErrors = _ref /*:: */.displayErrors,
    hasError = _ref /*:: */.hasError,
    hasValidation = _ref /*:: */.hasValidation,
    inputClassName = _ref /*:: */.inputClassName,
    ref = _ref /*:: */.inputRef,
    name = _ref /*:: */.name,
    placeholder = _ref /*:: */.placeholder,
    readOnly = _ref /*:: */.readOnly,
    setDisplayErrorsState = _ref /*:: */.setDisplayErrorsState,
    setLoadingState = _ref /*:: */.setLoadingState,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.input, inputClassName),
    "data-name": name,
    "data-testid": "Checkbox-input",
    disabled: disabled || readOnly
  }, _objectSpread({
    name: name,
    readOnly: readOnly,
    ref: ref
  }, props))), /*#__PURE__*/_react.default.createElement("span", null, children, placeholder && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.placeholder,
    "data-testid": "Checkbox-placeholder"
  }, placeholder)));
};
CheckboxInput.displayName = 'CheckboxInput';
CheckboxInput.defaultProps = {
  disabled: false,
  readOnly: false,
  type: 'checkbox'
};
var _default = exports.default = (0, _injectSheet.default)(Style)(CheckboxInput);
//# sourceMappingURL=CheckboxInput.js.map